import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { HomeProblem } from '../components/home/HomeProblem';
import { HomeOfferings } from '../components/home/HomeOfferings';
import { HomeJudgmentFlow } from '../components/home/HomeJudgmentFlow';
import { HomeEcosystem } from '../components/home/HomeEcosystem';
import { HomeAudiences } from '../components/home/HomeAudiences';
import { HomeInitiatives } from '../components/home/HomeInitiatives';
import { HomeCTA } from '../components/home/HomeCTA';
export function HomePage() {
  return <>
      <HomeHero data-id="element-1960" data-mp="2rzbcxe5j828c" />
      <HomeProblem data-id="element-1961" data-mp="36qbtk6gfn2fk" />
      <HomeOfferings data-id="element-1962" data-mp="36qu13z8jp32s" />
      <HomeJudgmentFlow data-id="element-1963" data-mp="36rdfj5yzl9c2" />
      <HomeEcosystem data-id="element-1964" data-mp="36rmywapj0i8s" />
      <HomeInitiatives data-id="element-1965" data-mp="31zlq4yrkh9ni" />
      <HomeAudiences data-id="element-1966" data-mp="31z269cicwb6u" />
      <HomeCTA data-id="element-1967" data-mp="31yttdkm8h5vn" />
    </>;
}